function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#quantumClearanceLogo_svg__clip0)"
}, /*#__PURE__*/React.createElement("mask", {
  id: "quantumClearanceLogo_svg__a",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 26,
  height: 26
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 0h25.304v25.091H0V0z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#quantumClearanceLogo_svg__a)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M25.304 12.546c0 6.925-5.664 12.545-12.648 12.545C5.663 25.091 0 19.471 0 12.545 0 5.62 5.664 0 12.648 0c6.992 0 12.656 5.62 12.656 12.546z",
  fill: "#136ED2"
})), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M27.835 22.619a2.436 2.436 0 01-2.45 2.428c-1.35 0-2.45-1.086-2.45-2.428a2.436 2.436 0 012.45-2.429c1.357.008 2.45 1.093 2.45 2.429z",
  fill: "#136ED2"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11.951 12.546c0 1.467-1.203 2.655-2.685 2.655s-2.685-1.188-2.685-2.655c0-1.468 1.203-2.656 2.685-2.656s2.685 1.188 2.685 2.655z",
  fill: "#fff"
}), /*#__PURE__*/React.createElement("mask", {
  id: "quantumClearanceLogo_svg__b",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 35,
  height: 26
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 25.091h165.762V0H0v25.091z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#quantumClearanceLogo_svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.993 15.201H5.18V9.89H2.993V15.2z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "quantumClearanceLogo_svg__c",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 35,
  height: 26
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 25.091h165.762V0H0v25.091z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#quantumClearanceLogo_svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M22.31 12.546c0 1.467-1.203 2.655-2.685 2.655a2.665 2.665 0 01-2.678-2.655c0-1.468 1.204-2.656 2.685-2.656a2.665 2.665 0 012.678 2.655z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "quantumClearanceLogo_svg__d",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 35,
  height: 26
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 25.091h165.762V0H0v25.091z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#quantumClearanceLogo_svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M13.352 15.201h2.187V9.89h-2.187V15.2z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("mask", {
  id: "quantumClearanceLogo_svg__e",
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 35,
  height: 26
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0 25.091h165.762V0H0v25.091z",
  fill: "#fff"
})), /*#__PURE__*/React.createElement("g", {
  mask: "url(#quantumClearanceLogo_svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M36.154 18.437a.514.514 0 00.06-.022c-.037.007-.06.022-.06.022z",
  fill: "#111"
})));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "quantumClearanceLogo_svg__clip0"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h35v25.091H0z"
})));

function SvgQuantumClearanceLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 26,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "0c9748d8f59f868f673a8a7bc6a165a4.svg";
export { SvgQuantumClearanceLogo as ReactComponent };